import { render, staticRenderFns } from "./PaginationComponents.vue?vue&type=template&id=527489fc"
import script from "./PaginationComponents.vue?vue&type=script&lang=js"
export * from "./PaginationComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports